"use strict";

var _require = require('./keyword_utils'),
  keyword = _require.keyword,
  word = _require.word;
exports.KeywordIdentity = keyword(/IDENTITY/i);
exports.KeywordIndex = keyword(/INDEX/i);
exports.KeywordWith = keyword(/WITH/i);
exports.KeywordOn = keyword(/ON/i);
exports.KeywordOff = keyword(/OFF/i);
exports.KeywordFilestream_On = keyword(/FILESTREAM_ON/i);
exports.KeywordPrimaryKey = keyword(/PRIMARY KEY/i);
exports.KeywordClustered = keyword(/CLUSTERED/i);
exports.KeywordNonclustered = keyword(/NONCLUSTERED/i);
exports.KeywordColumnStore = keyword(/COLUMNSTORE/i);
exports.KeywordReferences = keyword(/REFERENCES/i);
exports.KeywordForeignKey = keyword(/FOREIGN KEY/i);
exports.KeywordCheck = keyword(/CHECK/i);
exports.KeywordConstraint = keyword(/CONSTRAINT/i);
exports.KeywordUnique = keyword(/UNIQUE/i);
exports.KeywordHash = keyword(/HASH/i);
exports.KeywordBucket_Count = keyword(/BUCKET_COUNT/i);
exports.KeywordNFR = keyword(/NOT FOR REPLICATION/);
exports.KeywordOnDelete = keyword(/ON DELETE/i);
exports.KeywordOnUpdate = keyword(/ON UPDATE/i);
exports.KeywordSetNull = keyword(/SET NULL/i);
exports.KeywordSetDefault = keyword(/SET DEFAULT/i);
exports.KeywordNoAction = keyword(/NO ACTION/i);
exports.KeywordCascade = keyword(/CASCADE/i);
exports.KeywordContent = keyword(/CONTENT/i);
exports.KeywordDocument = keyword(/DOCUMENT/i);
exports.KeywordNull = keyword(/NULL/i);
exports.KeywordNotNull = keyword(/NOT NULL/i);
exports.KeywordDefault = keyword(/DEFAULT/i);
exports.KeywordFilestream = keyword(/FILESTREAM/i);
exports.KeywordCollate = keyword(/COLLATE/i);
exports.KeywordSparse = keyword(/SPARSE/i);
exports.KeywordRowGUIDCol = keyword(/ROWGUIDCOL/i);
exports.KeywordMasked = keyword(/MASKED/i);
exports.KeywordEncrypted = keyword(/ENCRYPTED/i);
exports.KeywordFunction = keyword(/FUNCTION/i);
exports.KeywordGeneratedAAR = keyword(/GENERATED ALWAYS AS ROW/i);
exports.KeywordStart = keyword(/START/i);
exports.KeywordEnd = keyword(/END/i);
exports.KeywordHidden = keyword(/HIDDEN/i);
exports.KeywordAsc = keyword(/ASC/i);
exports.KeywordDesc = keyword(/DESC/i);
exports.KeywordTextImage_On = keyword(/TEXTIMAGE_ON/i);
exports.KeywordPeriodForST = keyword(/PERIOD FOR SYSTEM_TIME/i);
exports.KeywordFileTable = keyword(/FILETABLE/i);
exports.KeywordTable = keyword(/TABLE/i);
exports.KeywordCreate = keyword(/CREATE/i);
exports.KeywordAs = keyword(/AS/i);
exports.KeywordPersisted = keyword(/PERSISTED/i);
exports.KeywordColumnSet = keyword(/XML COLUMN_SET FOR ALL_SPARSE_COLUMNS/i);
exports.KeywordInclude = keyword(/INCLUDE/i);
exports.KeywordIn = keyword(/IN/i);
exports.KeywordWhere = keyword(/WHERE/i);
exports.KeywordFor = keyword(/FOR/i);
exports.KeywordWithValues = keyword(/WITH VALUES/i);
exports.KeywordConnection = keyword(/CONNECTION/i);
exports.KeywordTo = keyword(/TO/i);
exports.KeywordAlter = keyword(/ALTER/i);
exports.KeywordAdd = keyword(/ADD/i);
exports.KeywordSet = keyword(/SET/i);
exports.KeywordRebuild = keyword(/REBUILD/i);
exports.KeywordSwitch = keyword(/SWITCH/i);
exports.KeywordEnable = keyword(/ENABLE/i);
exports.KeywordDisable = keyword(/DISABLE/i);
exports.KeywordNoCheck = keyword(/NOCHECK/i);
exports.KeywordDrop = keyword(/DROP/i);
exports.KeywordAlterColumn = keyword(/ALTER COLUMN/i);
exports.KeywordGo = keyword(/GO/i);
exports.KeywordBulkInsert = keyword(/BULK INSERT/i);
exports.KeywordInsert = keyword(/INSERT/i);
exports.KeywordUpdate = keyword(/UPDATE/i);
exports.KeywordMerge = keyword(/MERGE/i);
exports.KeywordTruncateTable = keyword(/TRUNCATE TABLE/i);
exports.KeywordBackup = keyword(/BACKUP/i);
exports.KeywordRestore = keyword(/RESTORE/i);
exports.KeywordCollate = keyword(/COLLATE/i);
exports.KeywordClose = keyword(/CLOSE/i);
exports.KeywordDeny = keyword(/DENY/i);
exports.KeywordExecute = keyword(/EXECUTE/i);
exports.KeywordExec = keyword(/EXEC/i);
exports.KeywordGrant = keyword(/GRANT/i);
exports.KeywordOpen = keyword(/OPEN/i);
exports.KeywordRevoke = keyword(/REVOKE/i);
exports.KeywordSet = keyword(/SET/i);
exports.KeywordBegin = keyword(/BEGIN/i);
exports.KeywordGet = keyword(/GET/i);
exports.KeywordEnd = keyword(/END/i);
exports.KeywordMove = keyword(/MOVE/i);
exports.KeywordReceive = keyword(/RECEIVE/i);
exports.KeywordSend = keyword(/SEND/i);
exports.KeywordRename = keyword(/RENAME/i);
exports.KeywordDelete = keyword(/DELETE/i);
exports.KeywordIf = keyword(/IF/i);
exports.KeywordSP_ADDEXTENDEDPROPERTY = keyword(/sp_addextendedproperty/i);
exports.LogicalOpIn = keyword(/IN/i);
exports.LogicalOpAnd = keyword(/AND/i);
exports.LessThan = word('<');
exports.GreaterThan = word('>');
exports.LParen = word('(');
exports.Comma = word(',');
exports.RParen = word(')');
exports.DoubleQuote = word('"');
exports.SingleQuote = word('\'');
exports.LBracket = word('[');
exports.RBracket = word(']');
exports.Equal = word('=');
exports.Semicolon = word(';');
exports.KeywordAtName = keyword(/@name/i);
exports.KeywordAtValue = keyword(/@value/i);
exports.KeywordAtLevel0Type = keyword(/@level0type/i);
exports.KeywordAtLevel0Name = keyword(/@level0name/i);
exports.KeywordAtLevel1Type = keyword(/@level1type/i);
exports.KeywordAtLevel1Name = keyword(/@level1name/i);
exports.KeywordAtLevel2Type = keyword(/@level2type/i);
exports.KeywordAtLevel2Name = keyword(/@level2name/i);